module.exports = __webpack_public_path__ + "img/soil.fdc24325.svg";